module.exports = __webpack_public_path__ + "img/ALZA.b0a848bf.svg";